import React, { useState } from 'react';
import restApi from '../../../api/Source';
import Footer from "../../../components/user/Footer/Footer";
import Header from "../../../components/user/Header/Header";
import { withRouter } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';
import ReactSpinner from 'react-bootstrap-spinner';

import './Cart.css';

// https://www.youtube.com/watch?v=GW9DCk-qZWk

function Cart(props) {

    const [description, setDescription] = useState('');
    const [displayModal, setDisplayModal] = useState(false);
    const [orderStatus, setOrderStatus] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const cart = props.cart;

    const navigateTo = (page) => {
        props.history.push(page);
    }
    
    if (localStorage.getItem("isAuthenticated") === false || localStorage.getItem("userRole") !== "USER") {
        navigateTo('/');
    }

    const handleHideModal = () => {
        setOrderStatus('');
        setDisplayModal(false);
    }

    const handleDisplayModal = (orderStatus) => {
        setOrderStatus(orderStatus);
        setDisplayModal(true);
    }

    const removeFromCart = (removedProduct) => {
        let updatedCart = cart.filter((product) => product !== removedProduct);
        props.setCart(
            updatedCart
        );
        // save to localStorage
        let stringCart = JSON.stringify(updatedCart);
        localStorage.setItem("cart", stringCart);
    }

    const getTotalSum = () => {
        return cart.reduce((sum, { price, quantity }) => sum + price * quantity, 0);
    }

    const decreaseQuantity = (product) => {
        if (product.quantity === 1) {
            removeFromCart(product);
        } else {
            let updatedCart = [...cart];
            
            updatedCart.find(
                (item) => product.articleNumber === item.articleNumber && 
                            product.supplierId === item.supplierId
                ).quantity--;

            props.setCart(updatedCart);

            // save to localStorage
            let stringCart = JSON.stringify(updatedCart);
            localStorage.setItem("cart", stringCart);
        }
    }

    const increaseQuantity = (product) => {
        let updatedCart = [...cart];

        updatedCart.find(
            (item) => product.articleNumber === item.articleNumber && 
                        product.supplierId === item.supplierId
            ).quantity++;

        props.setCart(updatedCart);

        // save to localStorage
        let stringCart = JSON.stringify(updatedCart);
        localStorage.setItem("cart", stringCart);
    }

    const handleDescription = (e) => {
        const text = e.target.value;
        setDescription(text);
    }

    const handleSubmitOrder = async() => {
        setIsSubmitting(true);
        const request = {
            user: {"username": localStorage.getItem("user"), "societyName": localStorage.getItem("societyName")},
            description: description,
            products: cart
        }
        
        try {
            await restApi.post("/services/submit", request);
            handleDisplayModal("Comanda plasata cu succes!");
            props.setCart([]);
            localStorage.removeItem("cart");
            setDescription('');
        } catch (error) {
            handleDisplayModal("Ceva nu a mers. Incearca din nou!");
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <div className="cart page-container">
            <div id="content-wrap">
                <Header {...props} />

                <div className="container-fluid mt-4">
                    <div className="row justify-content-center">
                        {cart.length === 0 ? (
                            <div className="col-12">
                                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                    <div className="text-center p-5">
                                        <h5 className="mb-3">Cosul dumneavoastra este gol.</h5>
                                        <p className="text-muted mb-4">Adaugati produse in cos pentru a continua.</p>
                                        <button type="button" className="btn btn-primary btn-lg" onClick={() => navigateTo('/products/main')}>Vezi produse</button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="col-12 col-md-6 col-lg-6 mb-4 mb-md-0">
                                    <div className="cart-items-list">
                                        {cart.map((product, idx) => (
                                            <div key={idx} className="card mb-3 shadow-sm">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                                                            <h6 className="text-muted mb-1 small">{product.articleNumber}</h6>
                                                            <h6 className="font-weight-bold mb-1">{product.productName}</h6>
                                                            <p className="text-secondary small mb-0">{product.supplierBrand}</p>
                                                        </div>
                                                        <div className="col-12 col-sm-6">
                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                <span className="small">Cantitate: <strong className="text-primary">{product.quantity}</strong></span>
                                                                <div className="btn-group" role="group">
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn btn-outline-secondary btn-sm" 
                                                                        onClick={() => decreaseQuantity(product)}
                                                                        disabled={isSubmitting}
                                                                    >
                                                                        -
                                                                    </button>
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn btn-outline-secondary btn-sm" 
                                                                        onClick={() => increaseQuantity(product)}
                                                                        disabled={isSubmitting}
                                                                    >
                                                                        +
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <p className="mb-0">
                                                                <small className="text-muted">Pret cu TVA: </small>
                                                                <strong className="text-success">{(product.price * product.quantity).toFixed(2)} RON</strong>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <button 
                                                        className="btn btn-danger btn-sm btn-block mt-3" 
                                                        onClick={() => removeFromCart(product)}
                                                        disabled={isSubmitting}
                                                    >
                                                        Elimina
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                        
                                {cart.length > 0 && 
                                    <div className="col-12 col-md-6 col-lg-6"> 
                                        <div className="card shadow-sm sticky-top" style={{ top: '20px' }}>
                                            <div className="card-body">
                                                <div className="border border-primary rounded p-3 mb-4 bg-light">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <h6 className="mb-0 font-weight-bold">Cost Total:</h6>
                                                        <h4 className="mb-0 font-weight-bold text-primary">{getTotalSum().toFixed(2)} RON</h4>
                                                    </div>
                                                </div>
                                                <div className="mb-4">
                                                    <label htmlFor="noter-text-area" className="font-weight-bold mb-2 d-block">Detalii suplimentare</label>
                                                    <textarea 
                                                        id="noter-text-area" 
                                                        name="textarea" 
                                                        className="form-control"
                                                        value={description} 
                                                        onChange={handleDescription}
                                                        disabled={isSubmitting}
                                                        rows="4"
                                                    />
                                                </div>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-primary btn-lg btn-block" 
                                                    onClick={handleSubmitOrder}
                                                    disabled={isSubmitting || cart.length === 0}
                                                >
                                                    {isSubmitting ? (
                                                        <>
                                                            <ReactSpinner type="border" color="white" size="1" />
                                                            <span style={{ marginLeft: '8px' }}>Se trimite...</span>
                                                        </>
                                                    ) : (
                                                        'Trimite comanda'
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </>
                        )}
                    </div>
                </div>

                <Modal show={displayModal} onHide={handleHideModal}>
                    <Modal.Header closeButton>
                    <Modal.Title>Comanda Dumneavoastra</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{orderStatus}</Modal.Body>
                    <Modal.Footer>
                    <Button variant="primary" onClick={handleHideModal}>
                        OK
                    </Button>
                    </Modal.Footer>
                </Modal>
            </div>
            <Footer />
        </div>
    );
}

export default withRouter(Cart)